import AirDatepicker from 'air-datepicker';
import KeyboardHelper from '../helpers/KeyboardHelper';
import Calendar from '../components/Calendar';
import DateHelper from '../helpers/DateHelper';
import dayjs from 'dayjs';
import {EventsDatesResponse} from '../types';
import {Helpers} from '../helpers/helpers';
import UrlService from '../services/UrlService';
import CitySelect from '../components/CitySelect';
import StringHelper from "../helpers/StringHelper";

type EventsResponse = {
    response: {
        "currentPage": number,
        "lastPage": number,
        "perPage": number,
        "from": number,
        "to": number,
        "total": number,
        "html": {
            "items": string;
            "pagination": string;
        }
    }
}


export default class EventsPage {
    private DATES_HAS_EVENTS_URL = '/api/events/available-dates';
    private EVENTS_URL = '/api/events/paginated';
    private $holder: JQuery;
    private readonly $calendarIcon: JQuery;
    private readonly $calendarRow: JQuery;
    private readonly $calendarRowWrapper: JQuery;
    private readonly $calendarDatepicker: JQuery;
    private readonly $calendarCloseButton: JQuery;
    private readonly $subTitle: JQuery;
    private readonly $eventsListCountResult: JQuery;
    private readonly $eventsListEmptyListResult: JQuery;
    private readonly $eventsListWrapper: JQuery;
    private readonly $paginationWrapper: JQuery;
    private $filtersForm: JQuery;

    private isOpenCalendar = false;
    private calendarRowInstance: Calendar | null = null;
    private airDatepicker: AirDatepicker<HTMLElement> | null = null;
    private citySelect: CitySelect | null = null;
    private eventsDatesResponse: string[] | null = null;

    private SHOW_CALENDAR_CLASS = 'show-calendar';

    private readonly selectors = {
        calendarIcon: '.js-calendar-icon',
        calendarDatePicker: '.js-date-picker',
        calendarBlock: '.js-calendar-row',
        closeCalendarButton: '.js-date-picker-close',
        customDatePicker: '.js-custom-datepicker',
        calendarRowWrapper: '.js-calendar-wrapper',
        subTitle: '.js-events-page-sub-title',
        eventListCountResult: '.js-list-count-result',
        eventsListEmptyListResult: '.js-events-page-empty-list-result',
        eventListWrapper: '.js-events-page-list',
        paginationWrapper: '.js-events-page-pagination-wrapper',
        filtersForm: '.js-events-page-filters-form',
        resetAllFilters: '.js-event-page-filters-reset-button',
        cityCustomSelect: '.js-city-select',
        typeRadioLabel: '.js-event-type-radio-label',
    };

    private stateCalendars: {
        from: Date | null;
        to: Date | null
    } = {
        from: null,
        to: null,
    }

    private currentPagePagination = 1;

    constructor($holder: JQuery) {
        this.$holder = $holder;
        this.$calendarIcon = this.$holder.find(this.selectors.calendarIcon);
        this.$calendarRow = this.$holder.find(this.selectors.calendarBlock);
        this.$calendarDatepicker = this.$holder.find(this.selectors.calendarDatePicker);
        this.$calendarCloseButton = this.$holder.find(this.selectors.closeCalendarButton);
        this.$calendarRowWrapper = this.$holder.find(this.selectors.calendarRowWrapper);
        this.$subTitle = this.$holder.find(this.selectors.subTitle);
        this.$eventsListCountResult = this.$holder.find(this.selectors.eventListCountResult);
        this.$eventsListEmptyListResult = this.$holder.find(this.selectors.eventsListEmptyListResult);
        this.$eventsListWrapper = this.$holder.find(this.selectors.eventListWrapper);
        this.$paginationWrapper = this.$holder.find(this.selectors.paginationWrapper);
        this.$filtersForm = this.$holder.find(this.selectors.filtersForm);

        this.toggleCalendarHandler = this.toggleCalendarHandler.bind(this);
        this.closeCalendar = this.closeCalendar.bind(this);
        this.openCalendar = this.openCalendar.bind(this);
        this.clickOutsideCalendarHandler = this.clickOutsideCalendarHandler.bind(this);
        this.handleChangeDatesRow = this.handleChangeDatesRow.bind(this);
        this.clickPaginationHandler = this.clickPaginationHandler.bind(this);
        this.typeRadioMouseUpHandler = this.typeRadioMouseUpHandler.bind(this);

        void this.init();
    }

    private async init() {
        const $rowCalendar = this.$calendarRowWrapper.eq(0);
        const $citySelect = this.$holder.find(this.selectors.cityCustomSelect).eq(0);
        const datesResponse = await this.fetchDates();

        this.calendarRowInstance = new Calendar($rowCalendar, this.handleChangeDatesRow, datesResponse.response.items);
        this.citySelect = new CitySelect($citySelect);
        this.initAirDatepicker(datesResponse);
        this.initEvents();
    }

    private initEvents(): void {
        this.$calendarIcon.on('click', this.toggleCalendarHandler);
        this.$calendarCloseButton.on('click', this.closeCalendar);

        this.$paginationWrapper.on('click', 'a', this.clickPaginationHandler);

        $(document).on('click', this.clickOutsideCalendarHandler);
        $(document).on('keydown', (evt) => {
            if (!this.isOpenCalendar || !KeyboardHelper.isEsc(evt)) {
                return;
            }

            this.closeCalendar();
        });

        const $labels = this.$holder.find(this.selectors.typeRadioLabel);

        $labels.on('mousedown', (evt) => {
            const $input = $(evt.currentTarget).find('input');
            const isChecked = $input.prop('checked');

            if (isChecked) {
                $(evt.currentTarget).on('mouseup', this.typeRadioMouseUpHandler);
                return;
            }
        });


        this.$filtersForm.on('change', '.js-events-page-filters-item', () => {
            this.changeFiltersHandler(true);
        });

        this.$holder.on('click', this.selectors.resetAllFilters, () => {
            this.resetAllFilters();
        });
    }

    private initAirDatepicker(avaiableDates: EventsDatesResponse): void {
        const calendar = this.$calendarDatepicker.get(0);
        const buttonTarget = {
            content: 'Применить',
            className: 'datepicker-button target js-event-calendar-button disabled',
            onClick: (dp: AirDatepicker) => {
                const fromDate = dp.selectedDates[0] ?? null;
                const toDate = dp.selectedDates[1] ?? null;

                if (this.calendarRowInstance) {
                    this.calendarRowInstance.setState({
                        from: fromDate,
                        to: toDate,
                    });
                }

                this.setStateDates({
                    from: fromDate,
                    to: toDate,
                });

                this.changeFiltersHandler();
                this.closeCalendar();
            },
        }

        const buttonClear = {
            content: 'Очистить',
            className: 'datepicker-clear js-event-calendar-button disabled',
            onClick: (dp: AirDatepicker) => {
                if (this.calendarRowInstance) {
                    this.calendarRowInstance.setState({
                        from: null,
                        to: null,
                    });
                }

                this.setStateDates({
                    from: null,
                    to: null,
                });

                this.changeFiltersHandler();
                dp.clear();
                this.closeCalendar();
            }
        }

        const buttonClose = {
            content: '',
            className: 'calendar-row__datepicker-close',
            onClick: () => {
                this.resetAllFilters();
                this.closeCalendar();
            }
        }

        this.airDatepicker = new AirDatepicker(calendar, {
            position: "left",
            inline: false,
            classes: 'custom-datepicker js-custom-datepicker',
            buttons: [buttonClear, buttonTarget, buttonClose],
            range: true,
            isMobile: true,
            onRenderCell({date, cellType}) {
                if (cellType === 'day') {

                    const formatDate = dayjs(date).format('DD.MM.YYYY');
                    const hasEvents = avaiableDates.response.items.includes(formatDate);

                    return {
                        html: `<div class="custom-datepicker__cell-day ${hasEvents ? 'has-events' : 'disabled'}">${date.getDate()}</div>`,
                    };
                }
            },
            onSelect: ({date}) => {
                if (!Array.isArray(date)) {
                    return;
                }

                if (!date.length) {
                    this.processDisabledCalendarButtons({
                        from: null,
                        to: null,
                    })
                    return;
                }

                this.processDisabledCalendarButtons({
                    from: date[0] ?? null,
                    to: date[1] ?? null,
                });
            }
        });
    }

    private typeRadioMouseUpHandler(evt: JQuery.MouseUpEvent): void {
        evt.preventDefault();

        const $input = $(evt.currentTarget).find('input');

        setTimeout(() => {
            $input.prop('checked', false);

            $input.trigger('change');
        }, 5);

        $(evt.currentTarget).off('mouseup', this.typeRadioMouseUpHandler);
    }

    private processDisabledCalendarButtons(state: {
        from: Date | null;
        to: Date | null
    }): void {
        const $buttons = this.$holder.find('.js-event-calendar-button');

        if (!state.from && !state.to) {
            $buttons.addClass('disabled');
            return;
        }

        $buttons.removeClass('disabled');
    }

    private resetAllFilters(): void {
        this.setStateDates({
            from: null,
            to: null,
        });

        this.calendarRowInstance.setState(this.stateCalendars);
        this.airDatepicker.clear();

        this.citySelect?.resetValue();

        this.$filtersForm
            .find('.js-events-page-filters-item-types')
            .each((_, input) => {
                $(input).prop('checked', false);
            });

        this.changeFiltersHandler(true);
    }

    private fetchDates(): Promise<EventsDatesResponse> {
        return new Promise((resolve) => {
            const request = {
                dateFrom: dayjs().startOf('month').format('DD.MM.YYYY'),
            }

            void $.ajax(this.DATES_HAS_EVENTS_URL, {
                method: 'GET',
                dataType: 'json',
                data: request,
            }).done((response: EventsDatesResponse) => {
                this.eventsDatesResponse = response.response.items;
                resolve(response);
            });
        });
    }

    private setSubTitle(): void {
        if (!this.stateCalendars.from && !this.stateCalendars.to) {
            this.$subTitle.text('');
            return;
        }

        const fromDay = this.stateCalendars.from?.getDate() ?? '';
        const fromMonth = this.stateCalendars.from ? DateHelper.getMonthWithPlurals(this.stateCalendars.from) : '';
        const toDay = this.stateCalendars.to?.getDate() ?? '';
        const toMonth = this.stateCalendars.to ? DateHelper.getMonthWithPlurals(this.stateCalendars.to) : '';

        if (this.stateCalendars.from && this.stateCalendars.to) {
            this.$subTitle.text(`c ${fromDay}
            ${fromMonth}
             по ${toDay} ${toMonth}`
            );
            return;
        }

        if (this.stateCalendars.from) {
            this.$subTitle.text(`${fromDay} ${fromMonth}`)
            return;
        }

        this.$subTitle.text('');
    }

    private setCalendarClasses(): void {
        if (!this.stateCalendars.from && !this.stateCalendars.to) {
            this.$calendarRow.removeClass('has-dates');
            return;
        }

        this.$calendarRow.addClass('has-dates');
    }

    private setStateDates(newState: {
        from: Date | null,
        to: Date | null,
    }): void {
        this.stateCalendars = newState;
        this.setCalendarClasses();
        this.setSubTitle();
    }

    private handleChangeDatesRow(dateStates: {
        from: Date | null,
        to: Date | null,
    } | null): void {
        this.airDatepicker?.clear();

        this.setStateDates({
            from: dateStates?.from ?? null,
            to: dateStates?.to ?? null,
        });

        this.processDisabledCalendarButtons(this.stateCalendars);

        if (this.airDatepicker) {
            this.airDatepicker.selectDate(
                [dateStates?.from ?? null, dateStates?.to ?? null]
                    .filter((date) => date !== null)
            );
        }

        this.changeFiltersHandler();
    }

    private openCalendar(): void {
        if (this.isOpenCalendar) {
            return;
        }

        this.isOpenCalendar = true;
        this.$calendarRow.addClass(this.SHOW_CALENDAR_CLASS)
    }

    private closeCalendar(): void {
        if (!this.isOpenCalendar) {
            return;
        }

        this.isOpenCalendar = false;
        this.$calendarRow.removeClass(this.SHOW_CALENDAR_CLASS)
    }

    private toggleCalendarHandler(): void {
        if (this.isOpenCalendar) {
            this.closeCalendar();
        } else {
            this.openCalendar();
        }
    }

    private clickOutsideCalendarHandler(evt: JQuery.ClickEvent): void {
        const $target = $(evt.target);

        if (!this.isOpenCalendar
            || $target.closest(this.selectors.customDatePicker).length
            || $target.closest(this.$calendarIcon).length
            || $target.hasClass('custom-datepicker__cell-day')) {
            return;
        }
        this.resetAllFilters();
        this.closeCalendar();
    }

    private clickPaginationHandler(evt: JQuery.ClickEvent): void {
        evt.preventDefault();

        const $currentTarget = $(evt.currentTarget);
        const href = $currentTarget.attr('href');

        if (!href) {
            return;
        }

        const page = UrlService.getParamValueByName('page', href);

        if (!page) {
            return;
        }

        this.currentPagePagination = Number(page);
        this.changeFiltersHandler(false);
    }

    private getParamsEvents(): Array<JQuery.NameValuePair> {
        let result: Array<JQuery.NameValuePair> = [];

        result.push({
            name: 'dateFrom',
            value: this.stateCalendars.from ? DateHelper.getDateForRequest(this.stateCalendars.from) : '',
        });

        result.push({
            name: 'page',
            value: this.currentPagePagination.toString(),
        })

        if (this.stateCalendars.to) {
            result.push({
                name: 'dateTo',
                value: DateHelper.getDateForRequest(this.stateCalendars.to),
            });
        } else if (this.stateCalendars.from) {
            result.push({
                name: 'dateTo',
                value: DateHelper.getDateForRequest(this.stateCalendars.from),
            });
        }

        return [...result, ...this.$filtersForm.serializeArray()];
    }

    private changeFilterTimeoutId: NodeJS.Timeout | null = null;

    private changeFiltersHandler(isResetPagination = true): void {
        if (isResetPagination) {
            this.currentPagePagination = 1;
        }

        if (this.changeFilterTimeoutId) {
            clearTimeout(this.changeFilterTimeoutId);
        }

        this.changeFilterTimeoutId = setTimeout(() => {
            this.fetchEvents();
        }, 300);
    }

    private isLoading = false;

    private fetchEvents(): void {
        const params = this.getParamsEvents();
        const hasFilters = Helpers.hasFiltersValue(params.filter((param) => param.name !== 'page'));

        if (hasFilters) {
            this.$holder.addClass('has-filters')
        } else {
            this.$holder.removeClass('has-filters')
        }

        this.isLoading = true;
        this.$holder.addClass('is-loading');
        void $.ajax({
            url: this.EVENTS_URL,
            type: 'GET',
            dataType: 'json',
            data: params,
        }).done((data: EventsResponse) => {
            this.prepareEventsResponse(data);
            this.isLoading = false;

            if (!Helpers.isTopInViewPort(this.$holder)) {
                Helpers.scrollTo(this.$holder.get(0) as HTMLElement);
            }

            this.$holder.removeClass('is-loading');
        });
    }

    private prepareEventsResponse(data: EventsResponse): void {
        const totalCount = data.response.total;

        const countText = StringHelper.plural(['результат', 'результата', 'результатов'], totalCount);

        this.$eventsListCountResult.html(`${totalCount.toString()} ${countText}`);

        if (!totalCount) {
            this.$eventsListEmptyListResult.show();
            this.$eventsListWrapper.hide();
            this.$paginationWrapper.hide();
            return;
        }

        this.$eventsListEmptyListResult.hide();
        this.$eventsListWrapper.show().html(data.response.html.items);
        this.$paginationWrapper.show().html(data.response.html.pagination);
    }
}
